import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import api, { errMsg } from "@/lib/api";

export const ContactForm = () => {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error(t("required_field"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success(t("contact_success"));
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(errMsg(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="vl-card rounded-2xl p-6 sm:p-8 space-y-4" data-testid="contact-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs tracking-widest uppercase text-[var(--vl-stone)] mb-2">{t("full_name")}</label>
          <input value={form.name} onChange={(e) => set("name", e.target.value)} className="vl-input rounded-lg px-4 py-3 w-full" data-testid="contact-name-input" />
        </div>
        <div>
          <label className="block text-xs tracking-widest uppercase text-[var(--vl-stone)] mb-2">{t("phone")}</label>
          <input value={form.phone} onChange={(e) => set("phone", e.target.value)} className="vl-input rounded-lg px-4 py-3 w-full" data-testid="contact-phone-input" />
        </div>
      </div>
      <div>
        <label className="block text-xs tracking-widest uppercase text-[var(--vl-stone)] mb-2">{t("email")}</label>
        <input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="vl-input rounded-lg px-4 py-3 w-full" data-testid="contact-email-input" />
      </div>
      <div>
        <label className="block text-xs tracking-widest uppercase text-[var(--vl-stone)] mb-2">{t("contact_message")}</label>
        <textarea value={form.message} onChange={(e) => set("message", e.target.value)} rows={4} className="vl-input rounded-lg px-4 py-3 w-full resize-none" data-testid="contact-message-input" />
      </div>
      <button type="submit" disabled={loading} className="vl-btn-gold rounded-full px-7 py-3 text-sm tracking-widest uppercase font-medium flex items-center gap-2" data-testid="contact-submit-btn">
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} {t("contact_send")}
      </button>
    </form>
  );
};

export default ContactForm;
